<template>
  <ModalDialog
    v-bind="$dialog.dialog.value"
    :shown="shown"
    :onAccept="onAccept"
    :onCancel="onCancel"
    :onClose="onClose"
  />
</template>

<script lang="ts">
export default {
  computed: {
    shown(): boolean {
      return Boolean(this.$dialog.dialog.value && this.$dialog.open.value)
    },
    onAccept(): (() => void) | undefined {
      if (this.$dialog.dialog.value?.acceptCallback) {
        return async () => {
          await this.$dialog.closeDialog()
          await this.$dialog.dialog.value?.acceptCallback?.()
        }
      }
      return undefined
    },
    onCancel(): (() => void) | undefined {
      if (this.$dialog.dialog.value?.cancelCallback) {
        return async () => {
          await this.$dialog.closeDialog()
          await this.$dialog.dialog.value?.cancelCallback?.()
        }
      }
      return undefined
    },
    onClose(): () => void {
      if (this.$dialog.dialog.value?.cancelCallback) {
        return async () => {
          await this.$dialog.closeDialog()
          await this.$dialog.dialog.value?.cancelCallback?.()
        }
      }
      return this.$dialog.closeDialog
    },
  },
}
</script>
